import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { trackVisibleHeight } from './common/visibleHeight';
//store
import store from "./Store"
import { Provider } from 'react-redux';
import AppErrorBoundary from './clientErrors/AppErrorBoundary';
import { installGlobalErrorReporting } from './clientErrors/clientErrorReporter';
// import { Provider } from 'react-redux';

trackVisibleHeight();
installGlobalErrorReporting();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <AppErrorBoundary>
  <Provider store={store}>

    <App />
    </Provider>
  </AppErrorBoundary>

  //  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
